module.exports = __webpack_public_path__ + "img/aboutUsbg2.6576ac20.png";